import gql from 'graphql-tag';

export const DEFERRED_FEATURE_QUERY = gql`
  query DeferredFeature($token: String!, $integrationType: String!) {
    otpLoginContext(token: $token, integrationType: $integrationType) {
      __typename
      context
    }
  }
`;
